import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { Text, Content as ContentDiv, Heading, Amount } from './styled';
import { convertToRupiah } from '../../utils/Helpers';
import { getSelectedPayment } from '../../helpers/snap';
import VANumberPlaceholder from '../PageInvoice/Detail/Invoice/Midtrans/VANumberPlaceholder'

const Content = props => (
  <ContentDiv>
    {/* <Text style={{margin: 0}}>{props.productName}</Text> */}
    <Heading id="paymentOrderId">
      ORD ID {props.orderId}
    </Heading>
    <Amount>
      <Heading className="currency-tag currency-tag__default text-center text-block">
        {props.totalAmount? `IDR. ${convertToRupiah(parseFloat(props.totalAmount))}`: 'IDR. -'}
      </Heading>
    </Amount>
    <Text style={{margin: 0}}>Payment using <strong>{getSelectedPayment(props.paymentMethod, props.bankCode)}</strong></Text>
    {
      props.vaNumber?
        <VANumberPlaceholder vaNumber={props.vaNumber}/>
      : null
    }
  </ContentDiv>
)

export default Content;